<div *ngFor="let t of tabs" class="flex-half btn-option-holder">
    <rl-box-tab [tab]="t" (click)="onSelect.emit(t.code)" class="box-tab"></rl-box-tab>
</div>